import { GoldenDomeAppSchema } from "@redotech/redo-model/golden-dome-apps";
import * as z from "zod";

export const getGoldenDomeApps = {
  name: "getGoldenDomeApps" as const,
  input: z.null(),
  output: z.array(GoldenDomeAppSchema),
};
